/**
 * Created by saeed on 12/29/2016.
 */
import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {
  API_URL_GET_COMPANY_LIST_BY_PARENT_ID,
  API_URL_GET_SERVICE_BY_SERVANT_ID, API_URL_GET_VIDEO_CALL_SETTING_BY_ORDER_BAG_ITEM_ID,
  GET_MEETING_URL_API_URL
} from '../constants';
import {BaseHttpService} from "../base-http-service";
import {MeetingVM} from "../../models/MeetingVM.model";
// import jsSHA from "jssha";
import {MeetingUserVM} from "../../models/MeetingUserVM.model";
import {OrderBagVM} from "../../models/OrderBagVM.model";
import {MeetingResponseVM} from "../../models/MeetingResponseVM.model";
import {VideoCallSettingVM} from "../../models/VideoCallSettingVM.model";
import {VideoCallSettingInfoVM} from "../../models/VideoCallSettingInfoVM.model";

@Injectable()
export class VideoCallService {
  // Resolve HTTP using the constructor
  constructor(private http: HttpClient ) {


  }

  getMeetingUrl(orderBagItemId:number):Observable<any>{
    // return this.http.get(IS_VIDEO_MEETING_RUNNING_API_URL+ '/' + orderBagItemId);
    if (orderBagItemId) {
      return this.http.get(GET_MEETING_URL_API_URL+ '/' + orderBagItemId).map((res:Response) => {
        return res;
      })
      //...errors if any
        .catch((error:any) => Observable.throw(error || 'Server error'));
      //   }

    }

  }

  getVideoCallSettingByOrderBagItemId(orderBagItemId:number):Observable<VideoCallSettingInfoVM>{
    // return this.http.get(IS_VIDEO_MEETING_RUNNING_API_URL+ '/' + orderBagItemId);
    if (orderBagItemId) {
      return this.http.get(API_URL_GET_VIDEO_CALL_SETTING_BY_ORDER_BAG_ITEM_ID+ '?orderBagItemId=' + orderBagItemId).map((res:Response) => {
        return res;
      })
      //...errors if any
        .catch((error:any) => Observable.throw(error || 'Server error'));
      //   }


    }

  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/video-call/video-call.service.ts